import React from 'react';
import { SyncStatus } from '../../types/orders';
import { formatDateTime } from '../../utils/dateUtils';

interface SyncStatusIndicatorProps {
  syncStatus: SyncStatus | null | undefined;
}

export const SyncStatusIndicator: React.FC<SyncStatusIndicatorProps> = ({ syncStatus }) => {
  if (!syncStatus) return null;

  return (
    <div className="mb-4 text-sm text-gray-500">
      Last synced: {syncStatus.sync_completed_at ? formatDateTime(syncStatus.sync_completed_at) : 'Never'}
      {syncStatus.status === 'error' && (
        <span className="text-red-600 ml-2">
          (Error: {syncStatus.error_message})
        </span>
      )}
    </div>
  );
};

